import {ResponseStatus} from "../../actions/types";
import {RecipientsSliceData} from "../slices/recipients.slice";
import {PayloadAction} from "@reduxjs/toolkit";
import {PagingDataModel} from "../../pages/shared/models/paging-data.model";
import {Recipient} from "../../pages/shared/models/user/recipient/recipient";

export function handleGetMyRecipients(state: RecipientsSliceData, status: ResponseStatus, payload: any): void {
    switch (status) {
        case ResponseStatus.PENDING:
            state.isLoading = true;
            state.errors = payload?.errors;

            break;
        case ResponseStatus.FAIL:
            state.isLoading = false;
            state.errors = payload?.errors;

            break;
        case ResponseStatus.SUCCESS:
            state.isLoading = false;

            state.myRecipientsData = payload && payload.myRecipients
                ? {...payload.myRecipients}
                : {...state.myRecipientsData, recipients: [], totalItems: 0, currentPage: 0}

            break;
    }
}

export function handleGetAllRecipients(state: RecipientsSliceData, status: ResponseStatus, payload: any): void {
    switch (status) {
        case ResponseStatus.PENDING:
            state.isLoading = true;
            state.errors = payload?.errors;

            break;
        case ResponseStatus.FAIL:
            state.isLoading = false;
            state.errors = payload?.errors;

            break;
        case ResponseStatus.SUCCESS:
            state.isLoading = false;

            state.allRecipients = payload?.allRecipients?.recipients;

            break;
    }
}

export function onChangeRecipientInState (state: RecipientsSliceData, action: PayloadAction<Recipient>): void {
    const updatedRecipient = action.payload;
    const updatedRecipientIndex = state.myRecipientsData.recipients.findIndex(recipient => recipient.recipientId === updatedRecipient.recipientId);

    state.myRecipientsData.recipients[updatedRecipientIndex] = updatedRecipient;
}

export function onPaginationChange (state: RecipientsSliceData, action: PayloadAction<PagingDataModel>): void {
    state.myRecipientsData.pageSize = action.payload.pageSize;
    state.myRecipientsData.currentPage = action.payload.currentPage;
}